// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15Scn","rootMobile":"styles_rootMobile__28Moh"};